import { Coupon } from '@app/components/icons/coupon';
import { Play } from '@app/components/icons/play';
import { useFlags } from '@app/hooks/use-flags';
import React from 'react';

import { Tooltip } from '../../components';
import { FLAG_ENABLE_CH_DASHBOARD_ANALYTICS } from '../../constants';
import { InterHeaderStyles } from '../../styles';
import { formatDate, navigateToEvent } from '../../utils';
import { PopoverMenu } from './popover-menu';
import { ContactType } from './types';

export const EventsAttendedTemplate: any = ({
  data,
}: {
  data: {
    eventsCount: number;
    eventName: string;
    slug: string;
    eventStartTime: string;
    eventEndTime: string;
    email: string;
    eventExternalId: string;
    eventSlug: string;
    contactType: ContactType;
    eventCount?: number;
  };
}) => {
  const remainingCount = data.eventsCount - (data.eventCount || 1);
  const flags = useFlags();
  const enableCHDashboardAnalytics =
    flags?.[FLAG_ENABLE_CH_DASHBOARD_ANALYTICS];
  const activityType = data.eventExternalId ? 'event' : 'video';

  //Temporary fix for row height for hub lead with no activity
  if (!data.eventSlug) {
    return <div className="h-11">&nbsp;</div>;
  }

  return (
    <div className="flex items-start py-2">
      {activityType === 'event' && (
        <Tooltip
          tooltip={`${formatDate(data.eventStartTime)} -> ${formatDate(
            data.eventEndTime,
          )}`}
          placement="bottom-center"
          childClassName="truncate min-w-16 max-w-60 mr-[10px] px-3 py-1 rounded-2xl bg-active"
        >
          <button
            className={`w-full flex items-center gap-1 ${InterHeaderStyles} justify-start`}
            onClick={() => {
              navigateToEvent(data.eventSlug);
            }}
          >
            <Coupon className="size-4 shrink-0" />{' '}
            <span className="truncate">{data.eventName}</span>
          </button>
        </Tooltip>
      )}
      {activityType === 'video' && (
        <div
          className={
            'min-w-16 max-w-60 mr-[10px] px-3 rounded-2xl py-1 bg-active'
          }
        >
          <div
            className={`w-full flex text-left ${InterHeaderStyles} gap-1 items-center`}
          >
            <Play className="size-4 shrink-0" />{' '}
            <span className="truncate">{data.eventName}</span>
            {data.eventCount && data.eventCount > 1 && (
              <>
                {' '}
                <span className="text-xs flex items-center justify-center text-current bg-blue-500 text-white rounded-full px-2 h-4 w-auto shrink-0 ml-1">
                  {data.eventCount}
                </span>
              </>
            )}
          </div>{' '}
        </div>
      )}
      {remainingCount > 0 && (
        <PopoverMenu
          count={remainingCount}
          email={data.email}
          slug={data.eventSlug}
          icon={
            !enableCHDashboardAnalytics ? <Coupon className="size-4" /> : null
          }
        />
      )}
    </div>
  );
};
